import { RegisterComponent } from './register/register.component';

export const containers: any[] = [RegisterComponent];

export * from './register/register.component';
